import React from 'react'

function WhyBetOnUs() {
   return (
      <section className="cs-bg-theme-color-2 pb-5 pt-5 discover_benzatine ">
         <div className="container">
            <h2 className="section_heading_title mb-3 tech_title">
               Why Bet on Us?
            </h2>

            <p className="section_desc mb-5 core-value-sub">
               We are not here to play around; we have been in the game since
               2013. You have choices, which is why we are the team that will
               create your next big thing without any hassles and on schedule.
            </p>
         </div>
         <div className="container al_ml_features bet">
            <div className="features_row mb-3">
               <div className="feature_card">
                  <h3 className="feature_card_title">
                     Battle-Tested Experience
                  </h3>

                  <img
                     className="discover_benzatine_card_img"
                     width="265px"
                     height="176px"
                     src="/assets/svg/discover/Experience_1.png"
                     alt="Experience"
                  />
                  <div className="feature_card_border"></div>
                  <p className="feature_card_description">
                     Over a decade in the trenches means we’ve seen it
                     all—crashes, pivots, last-minute “oh crap” moments. We’ve
                     built over 200 apps, from scrappy startups to industry
                     giants, and we know what it takes to make yours a win. No
                     learning curve, just results.
                  </p>
               </div>
               <div className="feature_card">
                  <h3 className="feature_card_title">No-BS Pricing</h3>
                  <img
                     className="discover_benzatine_card_img"
                     width="265px"
                     height="176px"
                     src="/assets/svg/discover/Cost-Effective_1.png"
                     alt="Experience"
                  />
                  <div className="feature_card_border"></div>
                  <p className="feature_card_description">
                     We don’t play games with your budget. You get upfront
                     costs, no hidden fees, and a plan that maximizes every
                     dollar without skimping on quality. We deliver high-impact
                     tech at lean prices—because your money should work as hard
                     as we do.
                  </p>
               </div>
               <div className="feature_card">
                  <h3 className="feature_card_title">A Crew That Clicks</h3>
                  <img
                     className="discover_benzatine_card_img"
                     width="265px"
                     height="176px"
                     src="/assets/svg/discover/Team&Culture_1.png"
                     alt="Experience"
                  />
                  <div className="feature_card_border"></div>
                  <p className="feature_card_description">
                     Our team’s a well-oiled machine—coders, designers, and
                     strategists who thrive on collaboration and caffeine-fueled
                     debates. We’re not just colleagues; we’re a pack that’s got
                     each other’s backs, which means your project gets the full
                     force of our collective brainpower.
                  </p>
               </div>

               <div className="feature_card">
                  <h3 className="feature_card_title">Rock-Solid Systems</h3>
                  <img
                     className="discover_benzatine_card_img"
                     width="265px"
                     height="176px"
                     src="/assets/svg/discover/Infrastructure_1.png"
                     alt="Experience"
                  />
                  <div className="feature_card_border"></div>
                  <p className="feature_card_description">
                     We don’t just build apps—we build them to last. Our
                     infrastructure is bulletproof, from secure code to scalable
                     architecture that grows with you. Your app doesn’t just
                     launch—it dominates, because we’ve spent years perfecting
                     the foundation.
                  </p>
               </div>
            </div>
         </div>
      </section>
   )
}

export default WhyBetOnUs
